<template>
  <div id="systemTask">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('task.system')" >
                <el-select v-model="filterForm.businessSystem" :placeholder="$t('task.chooseSystem')" clearable>
                  <el-option
                    v-for="item in systemOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('task.name')" >
                <el-input v-model="filterForm.name" :placeholder="$t('task.enterName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('task.startTime')" >
                <el-date-picker
                  v-model="filterForm.dateRange"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="24">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onExport()">{{ $t('export') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="businessSystem"
                :label="$t('task.system')"
              >
                <template slot-scope="scope">
                  {{ getSystemName(scope.row.businessSystem) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('task.name')">
              </el-table-column>
              <el-table-column
                prop="startDate"
                :label="$t('task.startTime')"
                width="170"
              >
              </el-table-column>
              <el-table-column
                prop="cycle"
                :label="$t('task.taskPeriod')"
              >
              </el-table-column>
              <el-table-column
                prop="incompletion"
                :label="$t('task.notComplete')"
              >
              </el-table-column>
              <el-table-column
                prop="notReviewed"
                :label="$t('task.notAudit')"
              >
              </el-table-column>
              <el-table-column
                prop="completed"
                :label="$t('task.completed')"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                :label="$t('information.createTime')"
                :width="160"
              >
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="120">
                <template slot-scope="scope">
                  <el-button @click="seeDetail(scope.row)" type="text" size="small">{{ $t('see') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TaskManage',
  components: {
  },
  data: function () {
    return {
      systemOptions: [
      ],
      filterForm: {
        businessSystem: '', // 系统
        name: '', // 任务名称
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        dateRange: ['', ''], // 时间范围
      },
      initFilterForm: {
        businessSystem: '', // 系统
        name: '', // 任务名称
        startDate: '', // 开始时间
        endDate: '', // 结束时间
        dateRange: ['', ''], // 时间范围
      },
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
    }
  },
  mounted () {
    this.getSystemOptions()
  },

  methods: {
    getSystemOptions: async function () {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        console.log('res', res)
        this.systemOptions = _.map(res.data, (system) => ({
          itemKey: system.code,
          itemValue: system.desc,
        }))
        console.log('this.systemOptions', this.systemOptions)
      }
    },
    async onExport() {
      const submitData = _.cloneDeep(this.filterForm)
      submitData.current = this.tableConfig.current
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailinkUrl + "/toDo/toDoExport",
        data: submitData
      });
    },
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    seeDetail(row) {
      let siteUrl = this.getSystemUrl(row.businessSystem)
      let baseUrl = this.$tool.getUrlSite()
      window.open(baseUrl + siteUrl)
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      console.log('this.filterForm', this.filterForm)
      this.filterForm.startTime = this.filterForm.dateRange ? this.filterForm.dateRange[0] : ''
      this.filterForm.endTime = this.filterForm.dateRange ? this.filterForm.dateRange[1] : ''
      let res = await window.instance.post(window.retailinkUrl + '/toDo/listToDo', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    getSystemName: function (id) {
      const result = _.find(this.systemOptions, function(o) { return o.itemKey === id; })
      return result.itemValue
    },
    getSystemUrl: function (systemId) {
      let result;
      switch (systemId) {
        case 1:
          result = window.skipRetailinkUrl
          break
        case 2:
          result = window.listenUUrl
          break
        case 3:
          result = window.oprUrl
          break
        case 4:
          result = window.vmsUrl
          break
        case 5:
          result = window.skipRetailogUrl
          break
        case 6:
          result = window.skipWoUrl
          break
        case 7:
          result = window.openSurveyUrl
          break
      }
      return result
    }
  }
}
</script>

<style scoped lang="sass">
#systemTask

</style>



// WEBPACK FOOTER //
// src/pages/task/systemTask.vue